<h1 mat-dialog-title>An Error Occurred!</h1>
<mat-dialog-content class="mat-typography">
  <p>{{ data?.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Okay</button>
</mat-dialog-actions>
